import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface VerticalAppLayoutProps {
  mobileTitle: string;
  sidebarHeader: React.ReactNode;
  sidebarNav: React.ReactNode;
  sidebarFooter: React.ReactNode;
  sidebarStyle?: React.CSSProperties;
  children: React.ReactNode;
}

export default function VerticalAppLayout({
  mobileTitle,
  sidebarHeader,
  sidebarNav,
  sidebarFooter,
  sidebarStyle,
  children,
}: VerticalAppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex">
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 h-14 bg-sidebar flex items-center px-4 shadow">
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-2 text-sidebar-foreground"
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <h1 className="ml-3 font-semibold text-sidebar-foreground truncate">{mobileTitle}</h1>
      </div>

      <aside
        style={sidebarStyle}
        className={cn(
          'fixed left-0 top-14 z-40 w-64 bg-sidebar transition-transform duration-200 ease-in-out shrink-0',
          'h-[calc(100vh-3.5rem)] overflow-hidden',
          'lg:top-0 lg:sticky lg:h-screen lg:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0',
        )}
      >
        <div className="flex flex-col h-full">
          <div className="shrink-0 border-b border-sidebar-border">
            {sidebarHeader}
          </div>
          <nav className="flex-1 p-4 space-y-1 overflow-y-auto no-scrollbar">
            {sidebarNav}
          </nav>
          <div className="shrink-0 border-t border-sidebar-border p-4">
            {sidebarFooter}
          </div>
        </div>
      </aside>

      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <main className="flex-1 min-h-screen lg:ml-0 pt-14 lg:pt-0 min-w-0">
        {children}
      </main>
    </div>
  );
}
